import {
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/components/ui";
import { retrieveMassTortSearchQueryOptions } from "@/lib/data/react-query/mass-torts/mass-tort";
import { useQuery } from "@tanstack/react-query";
import { useId } from "react";

const clearFilter = "__clear_mass_tort_filter__";

export function DashboardMassTortPicker({
  value,
  onChange,
}: {
  value: string | undefined;
  onChange: (massTortId: string | undefined) => void;
}) {
  const fieldId = useId();
  const { data, isPending, isError } = useQuery(
    retrieveMassTortSearchQueryOptions(),
  );
  const selectedMassTort = data?.data.find((massTort) => massTort.id === value);

  return (
    <div className="space-y-2">
      <Label htmlFor={fieldId} className="text-sm font-medium">
        Mass tort
      </Label>
      <Select
        value={value ?? ""}
        onValueChange={(next) => {
          onChange(next === clearFilter ? undefined : next);
        }}
      >
        <SelectTrigger
          id={fieldId}
          className="bg-card h-10 w-full"
          aria-label="Filter by mass tort"
        >
          <SelectValue placeholder="Select mass tort">
            {value
              ? selectedMassTort?.title?.trim() || "Selected mass tort"
              : undefined}
          </SelectValue>
        </SelectTrigger>
        <SelectContent className="z-[110]" data-modal-popover="true">
          {value && (
            <>
              <SelectItem value={clearFilter}>Clear filter</SelectItem>
              <SelectSeparator />
            </>
          )}
          {isPending && (
            <SelectItem value="__loading__" disabled>
              Loading mass torts…
            </SelectItem>
          )}
          {isError && (
            <SelectItem value="__error__" disabled>
              Unable to load mass torts
            </SelectItem>
          )}
          {data?.data.map((massTort) => (
            <SelectItem key={massTort.id} value={massTort.id}>
              {massTort.title?.trim() || "Untitled mass tort"}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
